class DynamicUrl {
  constructor(openOnLoad = false) {
    this.openOnLoad = openOnLoad;

    this.getFromURL();

    document.addEventListener('url:update', this.updateURL.bind(this));
  }

  openSummary(accordion) {
    customElements.whenDefined('accordion-tab').then(() => {
      const accordionId = accordion === 'formulate' ? '#formulate-accordion' : '#customize-accordion';
      const details = document.querySelector(accordionId);

      if (!details) return;

      const tab = details.parentElement;

      details.style.overflow = 'hidden';
      if (tab) tab.open(details);
    });
  }

  changeIngredients(params, value) {
    const ingredients = value.split(',') ?? [];
    let ingredientsCount = 0;
    let filteredIngredients = [];

    for (const ingredient of ingredients) {
      const activeIngredient = document.querySelector(`[name="Ingredients[]"][data-handle="${ingredient}"]`);
      if (!activeIngredient) continue;

      if (ingredientsCount >= 2) {
        break;
      }

      filteredIngredients.push(ingredient);
      ++ingredientsCount;
      activeIngredient.checked = true;
      activeIngredient.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (filteredIngredients.length > 0) {
      params.set('ingredients', filteredIngredients.join(','));
    } else {
      params.delete('ingredients');
    }

    return { params, isChanged: ingredientsCount > 0 };
  }

  changeFragrance(params, value) {
    const newFragrance = document.querySelector(`[name="properties[Fragrance]"][data-handle="${value}"]`);

    if (!newFragrance) {
      params.delete('fragrance');
      return { params, isChanged: false };
    }

    newFragrance.checked = true;
    newFragrance.dispatchEvent(new Event('change', { bubbles: true }));

    return { params, isChanged: true };
  }

  changePackaging(params, value) {
    const activePackaging = document.querySelector(`[name="properties[Packaging]"][value="${CSS.escape(value)}"]`);

    if (!activePackaging) {
      params.delete('packaging');
      return { params, isChanged: false };
    }

    activePackaging.checked = true;
    activePackaging.dispatchEvent(new Event('change', { bubbles: true }));

    return { params, isChanged: true };
  }

  changeLabel(params, value) {
    const labelInput = document.querySelector(`[name="properties[Label]"]`);
    const activeLabel = value === 'after-checkout' ? document.querySelector('#line-item-label-checkout') : document.querySelector('#line-item-label-design');

    if (!labelInput || !activeLabel) {
      params.delete('label');
      return { params, isChanged: false };
    }

    if (value !== 'after-checkout') {
      const newDesignOption = document.querySelector(`[name="label_design_option"][data-handle="${value}"]`);
      if (!newDesignOption) {
        params.delete('label');
        return { params, isChanged: false };
      }

      newDesignOption.checked = true;
      newDesignOption.parentElement.classList.add('active');
      newDesignOption.dispatchEvent(new Event('change', { bubbles: true }));
    }

    activeLabel.checked = true;
    activeLabel.dispatchEvent(new Event('change', { bubbles: true }));
    labelInput.dispatchEvent(new Event('change', { bubbles: true }));

    return { params, isChanged: true };
  }

  getFromURL() {
    let params = new URLSearchParams(window.location.search);
    let changes = {
      ingredients: false,
      fragrance: false,
      packaging: false,
      label: false
    }

    for (const [key, value] of params.entries()) {
      if (key === 'ingredients') {
        ({ params, isChanged: changes.ingredients } = this.changeIngredients(params, value));
      }
      else if (key === 'fragrance') {
        ({ params, isChanged: changes.fragrance } = this.changeFragrance(params, value));
      }
      else if (key === 'packaging') {
        ({ params, isChanged: changes.packaging } = this.changePackaging(params, value));
      }
      else if (key === 'label') {
        ({ params, isChanged: changes.label } = this.changeLabel(params, value));
      }
    }

    if (this.openOnLoad) {
      if (changes.ingredients || changes.fragrance) this.openSummary('formulate');
      if (changes.packaging || changes.label) this.openSummary('customize');
    }
  }

  updateURL() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(window.location.search);
    const ingredients = document.querySelectorAll(`[name="Ingredients[]"]:checked`);
    const fragrance = document.querySelector(`[name="properties[Fragrance]"]:checked`);
    const packaging = document.querySelector(`[name="properties[Packaging]"]:checked`);
    const label = document.querySelector(`[name="properties[Label]"]`);

    if (ingredients.length > 0) {
      const handles = Array.from(ingredients)
        .map(el => el.dataset.handle)
        .join(',');
      params.set('ingredients', handles);
    } else {
      params.delete('ingredients');
    }

    if (fragrance) params.set('fragrance', fragrance.dataset.handle);
    else params.delete('fragrance');

    if (packaging) params.set('packaging', packaging.value);
    else params.delete('packaging');

    if (label && label.value) {
      let labelValue = '';

      if (label.value === 'After checkout') {
        labelValue = 'after-checkout';
      } else {
        const activeDesignOption = document.querySelector(`[name="label_design_option"]:checked`);

        if (activeDesignOption) {
          labelValue = activeDesignOption.dataset.handle;
        }
      }

      if (labelValue !== '') params.set('label', labelValue);
    }
    else params.delete('label');

    const queryString = params.toString().replace(/%2C/g, ',');
    const newUrl = `${url.pathname}?${queryString}`;
    window.history.replaceState({}, '', newUrl);
  }
}